export default {
    MAIN_FLIGHT: {
        value: 0,
        title: 'Start - Zwischenstopp'
    },
    SUB_FLIGHT: {
        value: 1,
        title: 'Zwischenstopp - Ziel'
    },
    toArray()
    {
        return [
            this.MAIN_FLIGHT,
            this.SUB_FLIGHT
        ]
    }
}